import { render } from "./FormularioTravesia.vue?vue&type=template&id=3346c227&ts=true"
import script from "./FormularioTravesia.vue?vue&type=script&lang=ts"
export * from "./FormularioTravesia.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__